/*
 *  Carousel Section
 *    Superclass for any carousel section you build, provides nice defaults that
 *    can be provided as data attributes from the wrapped container.
 *
 *  Version:
 *    1.0.0 - 2018/11/27
 */
import $ from 'jquery';
import 'slick-carousel';

import { ShopifySection } from './../../sections/ShopifySection';
import * as ResponsiveSizes from './../../settings/Responsive';
import { refreshThumbnails } from './../../objects/product/ProductThumbnail';

export class CarouselSection extends ShopifySection {
  constructor(container) {
    super(container);

    this.options = {
      mobileFirst: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      swipeToSlide: true,
      arrows: false,
      responsive: [
        {
          breakpoint: ResponsiveSizes.xsmall-1,
          settings: { slidesToShow: 3, slidesToScroll: 3 }
        },
        {
          breakpoint: ResponsiveSizes.small-1,
          settings: { slidesToShow: 3, slidesToScroll: 3, arrows: true }
        }
      ]
    };

    container.on('init', e => refreshThumbnails());
    container.on('reInit', e => refreshThumbnails());
    container.on('destroy', e => refreshThumbnails());
  }

  initCarousel(carouselElement, moreOverrides) {
    moreOverrides = moreOverrides || {};
    let slick = carouselElement.slick({
      ...this.options,
      ...this.optionOverrides(),
      ...moreOverrides
    });

    refreshThumbnails();

    return slick;
  }


  optionOverrides() { return {}; }

  reSlick(size, carouselElement, moreOverrides) {
    $(window).on('resize', () => this.onResize(size, carouselElement, moreOverrides));
  }

  onResize(size, carouselElement, moreOverrides) {
    // if($(window).width() < size-1) return;
    if(this.timer) clearTimeout(this.timer);

    this.timer = setTimeout(() => {
      if(carouselElement.hasClass('slick-initialized')) return;
      this.initCarousel(carouselElement, moreOverrides);
      this.timer = null;
    }, 100);
  }
}
